import { c as _c } from "react/compiler-runtime";
import { aspCond } from '@module/helpers/conditions/condition';
import { cn } from '@module/lib/utils';
import { useASPInfo } from '@module/queries/asp/query';
import { useFetchGetSitePresetQuery } from '@module/queries/preset/presetQueryHooks';
import CompanyInfo from '@pc/components/molecules/footer/CompanyInfo';
import FooterNotice from '@pc/components/molecules/footer/FooterNotice';
import PolicyLinks from '@pc/components/molecules/footer/PolicyLinks';
import SocialMediaLinks from '@pc/components/molecules/footer/SocialMediaLinks';
import ASPNewCustomFooter from './ASPNewCustomFooter';
import FooterBrandLink from './FooterBrandLink';

// footer.md 참고
function Footer(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  const {
    data: sitePreset
  } = useFetchGetSitePresetQuery();
  const aspInfo = useASPInfo();
  const shouldRenderASPNewCustomFooter = aspCond.if("new-asp") && aspInfo.data?.copyrightW === "Y" && sitePreset?.company.customCopyrightW;
  if (shouldRenderASPNewCustomFooter) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ASPNewCustomFooter />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== className) {
    t1 = cn("mt-[80px] w-full", className);
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FooterNotice />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section><div className="pb-[50px]"><PolicyLinks /><SocialMediaLinks /><FooterBrandLink /><CompanyInfo /></div></section>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1) {
    t4 = <footer id="main-footer" data-testid="footer" className={t1}>{t2}{t3}</footer>;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
export default Footer;